import React from 'react'
import { CreditApplicationStatus } from '_gql'

import { FormattedMessage } from '@divvy-web/i18n'
import Tag, {
  TAG_TYPE_DANGER,
  TAG_TYPE_DANGER_OUTLINE,
  TAG_TYPE_NEUTRAL,
  TAG_TYPE_SUCCESS_OUTLINE,
  TAG_TYPE_WARNING,
} from '@divvy-web/skylab.tag'

import { CreditApplicationDashboardStatus } from './types'

export const formatDate = (date) => (
  <FormattedMessage
    defaultMessage='{date, date, medium}'
    id='sputnik.utils__uS1Y/d'
    values={{ date: new Date(date) }}
  />
)

export const getDashboardStatusValue = (status?: CreditApplicationStatus | null): CreditApplicationDashboardStatus => {
  switch (status) {
    case CreditApplicationStatus.CLOSED_LOST:
    case CreditApplicationStatus.EXPIRED:
    case CreditApplicationStatus.CLOSED_AS_DUPLICATE:
    case CreditApplicationStatus.CUSTOMER_CANCELED:
      return CreditApplicationDashboardStatus.Expired
    case CreditApplicationStatus.IN_REVIEW:
      return CreditApplicationDashboardStatus.InReview
    case CreditApplicationStatus.NOT_STARTED:
    case CreditApplicationStatus.IN_PROGRESS:
      return CreditApplicationDashboardStatus.Incomplete
    case CreditApplicationStatus.OFFER_ACCEPTED:
    case CreditApplicationStatus.APPROVED:
    case CreditApplicationStatus.BUILD_ACCOUNT:
      return CreditApplicationDashboardStatus.AccountCreated
    case CreditApplicationStatus.REJECTED:
      return CreditApplicationDashboardStatus.Declined
    default:
      return CreditApplicationDashboardStatus.ActionNeeded
  }
}

export const getDashboardStatusTagProps = (
  status: CreditApplicationDashboardStatus,
): React.ComponentProps<typeof Tag> => {
  switch (status) {
    case CreditApplicationDashboardStatus.InReview:
      return {
        type: TAG_TYPE_NEUTRAL,
        children: (
          <FormattedMessage
            defaultMessage='In review'
            id='sputnik.utils__plemGH'
          />
        ),
      }
    case CreditApplicationDashboardStatus.Incomplete:
      return {
        children: (
          <FormattedMessage
            defaultMessage='Incomplete'
            id='sputnik.utils__kHwKVg'
          />
        ),
      }
    case CreditApplicationDashboardStatus.Expired:
      return {
        type: TAG_TYPE_DANGER,
        children: (
          <FormattedMessage
            defaultMessage='Expired'
            id='sputnik.utils__RahCRH'
          />
        ),
      }
    case CreditApplicationDashboardStatus.ActionNeeded:
      return {
        type: TAG_TYPE_WARNING,
        children: (
          <FormattedMessage
            defaultMessage='Action needed'
            id='sputnik.utils__7V6vuD'
          />
        ),
      }
    case CreditApplicationDashboardStatus.AccountCreated:
      return {
        type: TAG_TYPE_SUCCESS_OUTLINE,
        children: (
          <FormattedMessage
            defaultMessage='Account created'
            id='sputnik.utils__FRBgoF'
          />
        ),
      }
    case CreditApplicationDashboardStatus.Declined:
      return {
        type: TAG_TYPE_DANGER_OUTLINE,
        children: (
          <FormattedMessage
            defaultMessage='Declined'
            id='sputnik.utils__uRYIb9'
          />
        ),
      }
  }
}
